import axios from 'axios'
import { SignedFile, UploadedImage } from './utils'

export async function getSignedUrl(fileName: string, fileType: string): Promise<SignedFile> {
  const { data } = await axios.get(`/attachment/signedUrl?filename=${fileName}&content_type=${fileType}`)
  return data
}

export async function uploadImage(formData: FormData): Promise<UploadedImage> {
  const { data } = await axios.post('/attachment/new', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return data
}

export async function uploadFileToS3(url: string, file: File, fileType: string, tags: string) {
  return await axios.put(url, file, {
    headers: {
      'content-type': fileType + '; charset=utf-8',
      'x-amz-tagging': tags,
      'X-Requested-With': null,
      'content-disposition': 'attachment'
    }
  })
}
